import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Check if we're in the browser and fbq doesn't already exist
    if (typeof window === 'undefined' || window.fbq) return;
    // Initialize the fbq function
    window.fbq = function () {
      window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];
    // Create and append the script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel after script loads
    script.onload = () => {
      window.fbq('init', '771657228712288');
      window.fbq('track', 'PageView');
    };
    // Cleanup function
    return () => {
      // Optional: remove script on unmount if needed
    };
  }, []);
  return <noscript data-id="element-240">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=771657228712288&ev=PageView&noscript=1" alt="" data-id="element-241" />
    </noscript>;
}
// TypeScript declarations
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}